import isNaN from 'lodash/isNaN'

const round = n => (isNaN(Math.round(n)) ? 0 : Math.round(n))

export default round
